export class FreshServiceOffboardingForm {
    email: string;
    name: string;
    cpf: string;
    laptopTransportType: string;
    address?: string;
    number?: number;
    city?: string;
    district?: string;
    state?: string;
    cep?: string;
    collectDate?: Date | string;
    collectTime?: string;
    addressReference?: string;
    _id?: string;
    kind: number;
    companyName: string;
    cnpj: string;

    loadData(data: any) {
        if (data) {
            Object.entries(data).forEach(([key, value]) => {
                if (key) {
                    this[key] = value;
                }
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/models/FreshServiceOffboardingForm.model.ts